// extracted by mini-css-extract-plugin
module.exports = {"background":"Hero_background__23Pmz","header":"Hero_header__rypkM"};